// React Dependencies
import React, { Component, createRef } from 'react';

// External Dependencies
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import { Button, DialogTitle, DialogContent, DialogContentText, DialogActions, Dialog, Chip, Typography } from '@material-ui/core';
import { DropzoneArea } from 'material-ui-dropzone';
import { toast } from 'react-toastify';
import Lightbox from 'react-image-lightbox';

// Internal Dependencies
import apiService from '../../../services.js/apiService';
import FixedCropper from '../../global/image/FixedCropper';
import OverLoading from '../../global/OverLoading';
import SortableMedia from '../../global/SortableMedia/SortableMedia';
import { convertDataURLtoBlob } from '../../../common/util';
import Constants from '../../../common/constants';
import { IsEmpty } from '../../../common/checks';
import 'react-image-lightbox/style.css';

const useStyles = () => ({
  myDropZone: {
    position:        'relative',
    width:           '50%',
    height:          '15%',
    minHeight:       '100px',
    backgroundColor: '#ffffff',
    border:          0,
    boxShadow:       '0px 0px 1px 0px rgba(0, 0, 0, 1)',
    borderRadius:    5,
    borderColor:     '#000000',
    cursor:          'pointer',
    boxSizing:       'border-box',
  },
});

class Photos extends Component {
  constructor(props) {
    super(props);
    this.selectCategoryRef = null;
    this.dropZoneRef = null;
    this.ref = createRef();
    this.state = {
      mediaData:       '',
      alert:           false,
      openCropDialog:  false,
      originalFile:    null,
      currentFile:     null,
      src:             null,
      type:            null,
      uploadUrl:       '',
      base64:          '',
      images:          [],
      view:            false,
      viewImage:       '',
      cropping:        false,
      tempImgToDelete: [],
      loading:         false,
    };

    // Unit in bytes
    this.maxFileSize = 7340032;
    this.imageFormats = ['image/jpeg', 'image/jpg', 'image/png'];

    this.handleSave = this.handleSave.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.getBase64Image = this.getBase64Image.bind(this);
    this.handleView = this.handleView.bind(this);
    this.handleCrop = this.handleCrop.bind(this);
    this.handleUploadMultipleFile = this.handleUploadMultipleFile.bind(this);
  }

  componentDidMount() {
    const fetchPost = async () => {
      const pageHighlight = await apiService.getPageHighlight(this.props.pageHighlightId);
      if (pageHighlight) {
        this.setState({ images: IsEmpty(pageHighlight.images) ? [] : pageHighlight.images  });
      }
    };

    if (!IsEmpty(this.props.images)) {
      this.setState({ images: this.props.images });
    } else {
      fetchPost();
    }
  }

  componentDidUpdate(prefProps, prevState) {
    if (this.state.images !== prevState.images) {
      this.ref.current = prevState.images;
    }
  }

  b64toBlob = (dataURI) => {
    const byteString = atob(dataURI.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) { ia[i] = byteString.charCodeAt(i); }

    return new Blob([ab], { type: 'image/jpeg' });
  }

  handleCrop = (image) => {
    let uploadUrl = image.original;
    if (typeof image.originalFile === 'object') {
      uploadUrl = URL.createObjectURL(image.originalFile);
    }

    const temp = [];
    this.setState({ uploadUrl, cropping: true }, () => {
      temp.push(image);
      this.setState({ tempImgToDelete: temp }, () => {
        this.handleUploadUrl();
      });
    });
  }

  handleUploadUrl = () => {
    this.getBase64Image(this.state.uploadUrl, (base64image) => {
      this.setState({ openCropDialog: true, base64: base64image, type: 'url', currentFile: null },
        () => {
          const imgFile = this.b64toBlob(`data:image/*;base64,${this.state.base64}`);
          this.setState({ src: `data:image/*;base64,${this.state.base64}`, originalFile: new File([imgFile], 'o.jpeg', { type: 'image/jpeg' }) });
        });
    });
  }

  handleUploadMultipleFile = async (files) => {
    const currentImages = this.state.images;

    for (let i = 0; i < files.length; i += 1) {
      currentImages.push({ display: null, originalFile: files[i] });
    }

    this.setState({ images: currentImages }, () => {
      this.props.onPageHighlightImageChange(this.state.images);
    });
    this.dropZoneRef.updater.enqueueSetState(this.dropZoneRef, { fileObjects: [] });
  }

  handleUpload = (file) => {
    if (file.length > 0) {
      if (file.length === 1) {
        this.setState({ openCropDialog: true, type: 'upload' }, () => {
          if (this.state.openCropDialog) {
            this.setState({ currentFile: file[0] }, () => {
              const reader = new FileReader();
              reader.addEventListener('load', () => {
                this.setState({ src: reader.result });
                const originalImageBlob = convertDataURLtoBlob(reader.result);
                this.setState({ originalFile: new File([originalImageBlob], 'o.jpeg', { type: 'image/jpeg' }) });
              });
              reader.readAsDataURL(this.state.currentFile);
            });
          }
        });
        this.dropZoneRef.updater.enqueueSetState(this.dropZoneRef, { fileObjects: [] });
      } else {
        this.handleUploadMultipleFile(file);
      }
    }
  }

  getBase64Image = (imgUrl, callback) => {
    const img = new Image();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    img.onload = function () {
      canvas.width = img.width;
      canvas.height = img.height;

      ctx.drawImage(img, 0, 0);

      let dataURL = canvas.toDataURL('image/png');
      dataURL = dataURL.replace(/^data:image\/(png|jpg|jpeg);base64,/, '');
      callback(dataURL); // the base64 string
    };

    if (img.complete) {
      img.crossOrigin = Constants.CrossOrigin;
      img.src = imgUrl;
    }
  }

  handleSave = async (file) => {
    try {
      if (file) {
        const tempPostImages = this.state.images;

        const formData = new FormData();
        formData.append('image', file);
        formData.append('image', this.state.originalFile);
        formData.append('type', 'images');
        formData.append('pageId', this.props.pageId);

        if (this.state.cropping === true && this.state.tempImgToDelete.length > 0) {
          if (!IsEmpty(this.state.tempImgToDelete[0].originalFile)) {
            const index = this.state.images.findIndex((image) => image.originalFile && (this.state.tempImgToDelete[0].originalFile === image.originalFile));
            const finalArrayOfImages = this.state.images;

            formData.append('imgIndex', index);

            const result = await apiService.uploadPageHighlightMedia(this.props.pageHighlightId, formData, file);
            finalArrayOfImages.splice(index, 1, result);

            if (result) {
              const pageHighlight = await apiService.getPageHighlight(this.props.pageHighlightId);
              if (pageHighlight) {
                this.setState({
                  images:         finalArrayOfImages,
                  openCropDialog: false,
                  cropping:       false,
                  currentFile:    null,
                  src:            null,
                  type:           null,
                  uploadUrl:      '',
                  base64:         '',
                }, () => {
                  this.props.onPageHighlightImageChange(this.state.images);
                });
              }
            }
          } else {
            const [croppedImg] = this.state.tempImgToDelete;

            formData.append('original', croppedImg.original);
            const result = await apiService.uploadPageHighlightMedia(this.props.pageHighlightId, formData, file);

            if (!IsEmpty(result)) {
              const updatedImages = _.map(
                tempPostImages,
                (img) => (img.original === croppedImg.original ? result : img),
              );

              this.setState({
                images:         updatedImages,
                openCropDialog: false,
                cropping:       false,
                currentFile:    null,
                src:            null,
                type:           null,
                uploadUrl:      '',
                base64:         '',
              }, () => this.props.onPageHighlightImageChange(updatedImages));
            }
          }
          toast.success('Image cropped successfully.');
        } else {
            formData.append('imgIndex', null);

            const result = await apiService.uploadPageHighlightMedia(this.props.pageHighlightId, formData, file);
            if (result) {
              this.setState({
                images:         this.state.images.concat(result),
                openCropDialog: false,
                cropping:       false,
                currentFile:    null,
                src:            null,
                type:           null,
                uploadUrl:      '',
                base64:         '',
              }, () => {
                this.props.onPageHighlightImageChange(this.state.images);
                toast.success('Image uploaded successfully.');
              });
            }
        }
      }
    } catch (err) {
      this.setState({ openCropDialog: false });
      toast.error(err.message);
    }
  }

  handleDelete = async () => {
    try {
      if (!IsEmpty(this.state.mediaData.originalFile)) {
        const index = this.state.images.findIndex((image) => image.originalFile && (this.state.mediaData.originalFile === image.originalFile));
        const finalArrayOfImages = this.state.images;
        finalArrayOfImages.splice(index, 1);
        this.setState({
          images: finalArrayOfImages,
          alert:  false,
        });

        return;
      }

      let tempImgToDeleteData = this.state.mediaData;
      if (this.state.cropping === true && this.state.tempImgToDelete.length > 0) {
        tempImgToDeleteData = { ...this.state.tempImgToDelete[0] };
         this.setState({ mediaData: tempImgToDeleteData });
      }

      const params = {
        pageId:    this.props.pageId,
        mediaData: tempImgToDeleteData,
        fileType:  Constants.FileType.Image,
      };
      const response = await apiService.deletePageHighlightMedia(this.props.pageHighlightId, params);
      if (response) {
        const images = this.state.images.filter((image) => {
          if (image.display) {
            return image.display !== this.state.mediaData.display;
          } else {
            return image.original !== this.state.mediaData.original;
          }
        });
        this.setState({
          images,
          alert: false,
        },
          () => {
            this.props.onPageHighlightImageChange(this.state.images);
          });

        toast.success('Image successfully deleted.');
        return images;
      } else {
        this.setState({ alert: false });
        toast.error('An unexpected error has occurred');
      }
    } catch (err) {
      this.setState({ alert: false });
      toast.error(err.message);
    }
  }

  handleConfirmation = (mediaData) => {
    this.setState({ alert: true, mediaData });
  }

  handleClose = () => {
    this.setState({ openCropDialog: false, currentFile: null, alert: false, base64: '', view: false, type: null, uploadUrl: '', cropping: false, tempImgToDelete: [] });
  }

  handleSort = (images) => {
    this.setState({ loading: true, images }, () => {
      this.props.onSort(images);
      this.handleUpdate();
    });
  }

  handleView = (image) => {
    let viewImage = image.original;

    if (typeof image.originalFile === 'object') {
      viewImage = URL.createObjectURL(image.originalFile);
    }

    this.setState({ view: true, viewImage });
  }

  handleUpdate = async () => {
    try {
      const payload = {
        images: this.state.images,
        pageId: parseInt(this.props.pageId, 10),
      };
      await apiService.updatePageHighlight(this.props.pageHighlightId, payload);
      this.setState({ loading: false }, () => toast.success('Image position updated'));
    } catch (err) {
      this.setState({ loading: false });
      this.setState({ images: this.ref.current, loading: false });
      toast.error(err.message);
    }
  }

  handleErrorMessage = (file) => {
    if (!IsEmpty(file)) {
      if (!this.imageFormats.includes(file.type)) {
        toast.error('Only JPG, JPEG and PNG files are supported.');
        return false;
      }

      if (file.size > this.maxFileSize) {
        toast.error('Maximum file size of 7MB exceeded.');
        return false;
      }

      return true;
    }
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        {this.state.loading && <OverLoading />}

        <h5>Images</h5>
        <center>
          <DropzoneArea
            ref={(ref) => {
              this.dropZoneRef = ref;
            }}
            dropzoneText="Click to upload image"
            onChange={this.handleUpload.bind(this)}
            dropzoneClass={classes.myDropZone}
            showPreviewsInDropzone={false}
            showPreviews={false}
            showAlerts={false}
            clearOnUnmount
            getDropRejectMessage={(file) => this.handleErrorMessage(file)}
            filesLimit={15}
            maxFileSize={this.maxFileSize}
            acceptedFiles={['image/jpg', 'image/jpeg', 'image/png']}
          />
        </center>

        {this.state.images.length > 0
          ? (
            <Chip
              style={{
                backgroundColor: 'rgba(255,255,255,0)',
                width:           '150px',
                verticalAlign:   'bottom',
                margin:          '0px 0px -40px 35px',
              }}
              label={<Typography variant="h1">Cover Image</Typography>}
            />
          )
          : ''}

        {this.state.images.length > 0
          ? (
            <div style={{ position: 'relative' }}>
              <Chip
                style={{
                  backgroundColor: '#c0c0c0',
                  width:           '229px',
                  height:          '129px',
                  verticalAlign:   'bottom',
                  margin:          '75px 0px -160px 25px',
                }}
              />

              {this.state.images && (
                <SortableMedia
                  maxHt={117}
                  minHt={117}
                  maxWd={208}
                  minWd={208}
                  listMargin={50}
                  images={this.state.images}
                  handleCrop={this.handleCrop}
                  handleView={this.handleView}
                  handleDelete={(mediaData) => this.handleConfirmation(mediaData)}
                  handleSort={this.handleSort}
                />
              )}
            </div>
          )
          : ''}

        {this.state.view && (
          <Lightbox
            animationDisabled
            mainSrc={this.state.viewImage}
            onCloseRequest={() => {
              this.setState({
                view:      false,
                viewImage: null,
              });
            }}
          />
        )}

        <Dialog
          fullScreen
          open={this.state.openCropDialog}
          onClose={() => { this.handleClose(); }}
        >
          <FixedCropper
            width={16}
            height={9}
            cropPixelWidth={800}
            cropPixelHeight={450}
            outputPixelWidth={1120}
            outputPixelHeight={630}
            type={this.state.type}
            url={this.state.uploadUrl}
            src={this.state.src}
            file={this.state.currentFile}
            handleSave={this.handleSave}
            handleClose={this.handleClose}
            isCropping={this.state.cropping}
          />
        </Dialog>

        <Dialog
          fullWidth
          size="sm"
          open={this.state.alert}
          onClose={() => { this.handleClose(); }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Remove Image</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete the image?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { this.handleClose(); }} color="primary">Cancel</Button>
            <Button onClick={() => { this.handleDelete(); }} color="primary">Confirm</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(useStyles)(Photos);
